import logo from './logo.jpg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Jettsauce is not currently taking new orders
        </p>
        <a
          className="App-link"
          href="https://www.facebook.com/messages/t/101568768732893"
          target="_blank"
          rel="noopener noreferrer"
        >
          Have a question? Send us a message
        </a>
      </header>
    </div>
  );
}

export default App;
